<template>
  <div id="app">
    <!-- Dev Nav Doesnt get included in staging or production builds -->
    <DevNav v-if="isDevEnv"/>

    <router-view/>

    <LoginToContinueModal></LoginToContinueModal>
  </div>
</template>

<script>
// @ is an alias to /src
import DevNav from '@/components/dev/DevNav';

export default {
  props: [],
  components: {
    DevNav
  },
  data() {
    return {};
  },
  computed: {
    isDevEnv: () => process.env.NODE_ENV !== 'production'
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss"></style>
